import {
  FALLBACK_STOREFRONT_SETTINGS,
  LOGIN_METHOD,
  PAYMENT_METHOD,
  type LoginMethod,
  type PaymentMethod,
  type StorefrontSettings,
} from '../constants/settings'

export function isOtpLoginEnabled(method: LoginMethod): boolean {
  return method === LOGIN_METHOD.otp || method === LOGIN_METHOD.both
}

export function isGoogleLoginEnabled(method: LoginMethod): boolean {
  return method === LOGIN_METHOD.google || method === LOGIN_METHOD.both
}

export function isCodPaymentEnabled(method: PaymentMethod): boolean {
  return method === PAYMENT_METHOD.cod || method === PAYMENT_METHOD.both
}

export function isOnlinePaymentEnabled(method: PaymentMethod): boolean {
  return method === PAYMENT_METHOD.online || method === PAYMENT_METHOD.both
}

export function defaultCheckoutPayment(
  method: PaymentMethod,
): typeof PAYMENT_METHOD.cod | typeof PAYMENT_METHOD.online {
  if (method === PAYMENT_METHOD.online) return PAYMENT_METHOD.online
  return PAYMENT_METHOD.cod
}

export function checkoutPaymentChoices(method: PaymentMethod): PaymentMethod[] {
  if (method === PAYMENT_METHOD.both) {
    return [PAYMENT_METHOD.cod, PAYMENT_METHOD.online]
  }
  if (method === PAYMENT_METHOD.online) return [PAYMENT_METHOD.online]
  return [PAYMENT_METHOD.cod]
}

export function storefrontAuthLead(
  method: LoginMethod,
  copy: { leadOtp: string; leadGoogle: string; leadBoth: string },
): string {
  if (method === LOGIN_METHOD.google) return copy.leadGoogle
  if (method === LOGIN_METHOD.both) return copy.leadBoth
  return copy.leadOtp
}

function parseLoginMethod(value: unknown): LoginMethod {
  if (
    value === LOGIN_METHOD.otp ||
    value === LOGIN_METHOD.google ||
    value === LOGIN_METHOD.both
  ) {
    return value
  }
  return FALLBACK_STOREFRONT_SETTINGS.loginMethod
}

function parsePaymentMethod(value: unknown): PaymentMethod {
  if (
    value === PAYMENT_METHOD.cod ||
    value === PAYMENT_METHOD.online ||
    value === PAYMENT_METHOD.both
  ) {
    return value
  }
  return FALLBACK_STOREFRONT_SETTINGS.paymentMethod
}

export function normalizeStorefrontSettings(row: unknown): StorefrontSettings {
  const payload = (row ?? {}) as Record<string, unknown>
  const googleClientId =
    typeof payload.googleClientId === 'string' ? payload.googleClientId.trim() : ''

  return {
    loginMethod: parseLoginMethod(payload.loginMethod),
    paymentMethod: parsePaymentMethod(payload.paymentMethod),
    googleClientId: googleClientId || null,
    updatedAt: typeof payload.updatedAt === 'string' ? payload.updatedAt : '',
  }
}
